import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

// Validation Rules
const requiredText = "Required";
const required = value => !value && requiredText;

export const renderField = ({
  input,
  label,
  type,
  style,
  meta: { touched, error, warning },
  disabled,
}) => (
  <div>
    <input {...input} type={type} style={style} disabled={disabled} />
    {input.name === "Height" && <span> m</span>}
    {input.name === "Weight" && <span> kg</span>}
    {touched &&
      ((error && <div className="field__error">{error}</div>) ||
        (warning && <div className="field__error">{warning}</div>))}
  </div>
);

const RadioButton = props => {
  let fieldValidation = [];
  const {
    column,
    questionId,
    optionsIndex,
    optionsLength,
    style,
    value,
    membersWithUW,
    employeeGender,
    spouseGender,
  } = props;

  const femaleOnlyQuestions = [
    "PapSmear",
    "PapSmearDisorder",
    "MenstruationDisorder",
    "Gynaecological",
    "BreastCancer",
    "Pregnant",
    "HaveBeenPregnant",
  ];

  // Apply enable/disable check if membersWithUW data is available, hence set this to `false`
  const isFieldDisabled = questionId => {
    if (membersWithUW) {
      if (femaleOnlyQuestions.includes(questionId)) {
        if (column === "Emp" && membersWithUW.includes("Emp")) {
          return employeeGender !== "Female";
        }

        if (column === "Sp" && membersWithUW.includes("Sp")) {
          return spouseGender !== "Female";
        }
      }

      return !membersWithUW.includes(column);
    }

    return false;
  };

  // Apply new validation if membersWithUW data is available, hence use the old validation
  if (membersWithUW) {
    if (membersWithUW.includes(column) && !femaleOnlyQuestions.includes(questionId)) {
      fieldValidation = [required];
    }
  } else {
    if (column === "Emp" && !femaleOnlyQuestions.includes(questionId)) {
      fieldValidation = [required];
    }
  }

  let fieldStyle;
  if (optionsIndex === optionsLength - 1) {
    fieldStyle = { ...style };
  } else {
    fieldStyle = { textAlign: "center", ...style };
  }

  return (
    <td style={fieldStyle}>
      <Field
        name={column + questionId}
        type="radio"
        component={renderField}
        value={value}
        validate={fieldValidation}
        disabled={isFieldDisabled(questionId, value)}
      />
    </td>
  );
};

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  optionsIndex: PropTypes.number.isRequired,
  optionsLength: PropTypes.number.isRequired,
  column: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  style: PropTypes.object,
  membersWithUW: PropTypes.array,
  employeeGender: PropTypes.string,
  spouseGender: PropTypes.string,
};

export const RadioButtonGroupRow = props => {
  const { questionInputDisabled = false } = props;
  const style = { ...props.style };

  const elements = [];
  let key = 0;

  elements.push(
    <td style={style} key={key}>
      {props.questionNumber ? props.questionNumber : ""}
    </td>
  );
  key += 1;

  if (props.questionInput) {
    elements.push(
      <td style={style} key={key}>
        {props.questionDesc}
        <Field
          {...props.questionInput}
          type="text"
          id={props.questionInput.id ? props.questionInput.id : props.questionInput.name}
          component={renderField}
          disabled={questionInputDisabled}
        />
      </td>
    );
  } else {
    elements.push(
      <td style={style} key={key}>
        {props.questionDesc}
      </td>
    );
  }
  key += 1;

  for (let col = 0; col < props.columns.length; col++) {
    for (let opt = 0; opt < props.options.length; opt++) {
      elements.push(
        <RadioButton
          key={key}
          value={props.options[opt]}
          optionsIndex={opt}
          optionsLength={props.options.length}
          column={props.columns[col]}
          questionId={props.questionId}
          style={props.style}
          membersWithUW={props.membersWithUW}
          employeeGender={props.employeeGender}
          spouseGender={props.spouseGender}
        />
      );
      key += 1;
    }
  }

  return <tr>{elements}</tr>;
};

RadioButtonGroupRow.propTypes = {
  columns: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  questionNumber: PropTypes.number,
  questionId: PropTypes.string.isRequired,
  questionInput: PropTypes.object,
  questionDesc: PropTypes.string,
  style: PropTypes.object,
  membersWithUW: PropTypes.array,
  employeeGender: PropTypes.string,
  spouseGender: PropTypes.string,
  questionInputDisabled: PropTypes.bool,
};

export const MoreInfoGroupRow = props => {
  const style = { ...props.style };

  const elements = [];

  let name = `MoreInfoSubQNo${props.number}`;
  elements.push(
    <td style={style} key={`more-info-sub-q-no-${props.number}`}>
      <Field component={renderField} type="text" name={name} id={name} />
    </td>
  );

  name = `MoreInfoName${props.number}`;
  elements.push(
    <td style={style} key={`more-info-name-${props.number}`}>
      <Field component={renderField} type="text" name={name} id={name} />
    </td>
  );

  name = `MoreInfoDiagnosis${props.number}`;
  elements.push(
    <td style={style} key={`more-info-diagnosis-${props.number}`}>
      <Field component={renderField} type="text" name={name} id={name} />
    </td>
  );

  return <tr>{elements}</tr>;
};

MoreInfoGroupRow.propTypes = {
  number: PropTypes.number.isRequired,
  style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aia/components.js